import cx from "classnames";
import { type FC, type PropsWithChildren } from "react";

export interface PropertiesPaneSectionContainerProps {
	withBorder?: boolean;
	spaceBetween?: boolean;
	noPadding?: boolean;
}
export const PropertiesPaneSectionContainer: FC<
	PropsWithChildren<PropertiesPaneSectionContainerProps>
> = ({ children, withBorder, spaceBetween, noPadding }) => (
	<div
		className={cx("flex", "flex-col", "relative", "last:mb-6", {
			"border-b last:border-none": withBorder,
			"space-y-2": spaceBetween,
			"p-4": !noPadding,
		})}
	>
		{children}
	</div>
);
